/* eslint-disable jsx-a11y/label-has-associated-control */
import { Form } from 'semantic-ui-react';
import { useState } from '@wordpress/element';
import BarChart from '../BarChart';
import data from '../../data.json';

const RaceRelationsContainer = () => {
    const [raceRelations, setRaceRelations] = useState('Generally Bad');
    const [unique, setUnique] = useState(
        'The unique experiences of different racial/ethnic groups',
    );
    const [attention, setAttention] = useState('Too much');

    return (
        <>
            <div className="content-box">
                <h3 id="views-on-race-relations">Views of race relations</h3>
                <section id="race-relations">
                    <p>
                        Whites and blacks see the state of race relations very
                        differently. While whites are about equally likely to
                        say race relations are good as to say they are bad,
                        blacks hold decidedly negative views, with majorities
                        among all demographic groups of blacks saying race
                        relations are bad. Among whites, opinions are split
                        along party lines, with Democrats more likely than
                        Republicans or independents to say race relations are
                        bad. In fact, white and black Democrats are equally as
                        likely to say that race relations in the U.S. are
                        generally bad.{' '}
                    </p>
                    <div className="chart-container">
                        <h4 className="chart-title">
                            Race relations in the United States are ...
                        </h4>
                        <div className="radio-container">
                            {/* <input
                                type="radio"
                                className={'Generally Good' === raceRelations}
                                checked={'Generally Good' === raceRelations}
                                value="Generally Good"
                                onClick={() =>
                                    setRaceRelations('Generally Good')
                                }
                            />
                            <label>
                                <span />
                                Generally good
                            </label>
                            <input
                                type="radio"
                                className={'Generally Bad' === raceRelations}
                                checked={'Generally Bad' === raceRelations}
                                value="Generally Bad"
                                onClick={() =>
                                    setRaceRelations('Generally Bad')
                                }
                            />
                            <label>
                                <span />
                                Generally bad
                            </label> */}
                            <Form.Radio
                                label="Generally Good"
                                checked={'Generally Good' === raceRelations}
                                value="Generally Good"
                                onClick={() =>
                                    setRaceRelations('Generally Good')
                                }
                            />
                            <Form.Radio
                                label="Generally Bad"
                                checked={'Generally Bad' === raceRelations}
                                value="Generally Bad"
                                onClick={() =>
                                    setRaceRelations('Generally Bad')
                                }
                            />
                        </div>
                        {'Generally Bad' === raceRelations ? (
                            <BarChart data={data.generallyBad} />
                        ) : (
                            <BarChart data={data.generallyGood} />
                        )}
                    </div>
                </section>
                <section id="how-to-improve">
                    <p>
                        When it comes to improving race relations, blacks are
                        evenly divided on whether it is more important to focus
                        on the things racial and ethnic groups have in common or
                        on what makes each group unique. By contrast, whites are
                        about twice as likely to say the focus should be on
                        commonalities rather than differences.
                    </p>
                    <div className="chart-container">
                        <h4 className="chart-title">
                            To improve race relations, it is more important to
                            focus on ...
                        </h4>
                        <div className="radio-container">
                            {/* <Form.Group widths="equal"> */}
                            <Form.Radio
                                label="The unique experiences of different racial/ethnic groups"
                                checked={
                                    'The unique experiences of different racial/ethnic groups' ===
                                    unique
                                }
                                value="The unique experiences of different racial/ethnic groups"
                                onClick={() =>
                                    setUnique(
                                        'The unique experiences of different racial/ethnic groups',
                                    )
                                }
                            />
                            <Form.Radio
                                label="What different groups have in common"
                                checked={
                                    'What different groups have in common' ===
                                    unique
                                }
                                value="What different groups have in common"
                                onClick={() =>
                                    setUnique(
                                        'What different groups have in common',
                                    )
                                }
                            />
                            {/* </Form.Group> */}
                        </div>
                        {'The unique experiences of different racial/ethnic groups' ===
                        unique ? (
                            <BarChart data={data.uniqueExperiences} />
                        ) : (
                            <BarChart data={data.inCommon} />
                        )}
                    </div>
                </section>
                <section id="attention-to-race">
                    <p>
                        Whites are about twice as likely as blacks to say there
                        is too much attention paid to race and racial issues in
                        the country these days. About six-in-ten blacks say too
                        little attention is paid to these issues. Among whites,
                        men, those over 30 and Republicans are more likely to
                        say we pay too much attention to race and racial issues.{' '}
                    </p>
                    <div className="chart-container">
                        <h4 className="chart-title">
                            There is ______ attention paid to race and racial
                            issues in our country these days
                        </h4>
                        <div className="radio-container">
                            {/* <Form.Group widths="equal"> */}
                            <Form.Radio
                                label="Too much"
                                checked={'Too much' === attention}
                                value="Too much"
                                onClick={() => setAttention('Too much')}
                            />
                            <Form.Radio
                                label="Too little"
                                checked={'Too little' === attention}
                                value="Too little"
                                onClick={() => setAttention('Too little')}
                            />
                            <Form.Radio
                                label="About the right amount"
                                checked={'About the right amount' === attention}
                                value="About the right amount"
                                onClick={() =>
                                    setAttention('About the right amount')
                                }
                            />
                            {/* </Form.Group> */}
                        </div>
                        {'Too much' === attention && (
                            <BarChart data={data.tooMuchAttention} />
                        )}
                        {'Too little' === attention && (
                            <BarChart data={data.tooLittleAttention} />
                        )}
                        {'About the right amount' === attention && (
                            <BarChart data={data.rightAttention} />
                        )}
                    </div>
                </section>
            </div>
        </>
    );
};

export default RaceRelationsContainer;
